import { createActions, createReducer } from 'reduxsauce'

import ContratoLicitacaoService from '../../servicos/ConsultaContratoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaContratoLicitacaoInicio: [],
    buscaContratoLicitacaoSucesso: ['contratoLicitacao'],
    buscaContratoLicitacaoErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaContratoLicitacao = filtro => {
    return dispatch => {
        dispatch(Creators.buscaContratoLicitacaoInicio())
        let serv = new ContratoLicitacaoService()
        return serv
            .consultarPorLicitacao(filtro)
            .then(response => dispatch(Creators.buscaContratoLicitacaoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaContratoLicitacaoErro(error)))
    }
}

const buscaContratoLicitacaoInicio = (state = INITIAL_STATE, action) => {
    return { ...state, carregando: true, erro: null }
}

const buscaContratoLicitacaoErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaContratoLicitacaoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.contratoLicitacao, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_CONTRATO_LICITACAO_INICIO]: buscaContratoLicitacaoInicio,
    [Types.BUSCA_CONTRATO_LICITACAO_ERRO]: buscaContratoLicitacaoErro,
    [Types.BUSCA_CONTRATO_LICITACAO_SUCESSO]: buscaContratoLicitacaoSucesso,
})
